import React, { useState } from 'react';
import {
  Box,
  Card,
  CardHeader,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography
} from '@mui/material';
import { styled } from '@mui/material/styles';
import ReactPlayer from 'react-player';

// Styled components for consistent look
const RootStyle = styled(Card)(({ theme }) => ({
  padding: theme.spacing(3),
  margin: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[3]
}));

const CameraContainer = styled(Box)(({ theme }) => ({
  height: '400px',
  overflow: 'hidden',
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(1)
}));

function CameraFeedPage() {
  // Camera list with multiple streams per site
  const [cameras, setCameras] = useState([
    { id: 'cam1', site: 'Carryduff', url: 'https://weighhub.irishwaste.online/cam1/index.m3u8' }
    // { id: 'cam2', site: 'Carryduff', url: 'https://weighhub.irishwaste.online/cam1/index.m3u8' },
    // { id: 'cam3', site: 'Belfast', url: 'https://weighhub.irishwaste.online/cam1/index.m3u8' },
    // { id: 'cam4', site: 'Belfast', url: 'https://weighhub.irishwaste.online/cam1/index.m3u8' }
  ]);

  // Group cameras by site
  const sites = Array.from(new Set(cameras.map((cam) => cam.site)));
  const [selectedSite, setSelectedSite] = useState(sites[0] || '');
  const filteredCameras = cameras.filter((cam) => cam.site === selectedSite);

  // Handle site selection
  const handleSiteChange = (event: any) => {
    setSelectedSite(event.target.value);
  };

  return (
    <RootStyle>
      <Grid container spacing={2}>
        {/* Header and Site Selector */}
        <Grid item xs={12}>
          <CardHeader
            title="Live Camera Feeds"
            subheader="View multiple camera streams from selected site"
            sx={{ mb: 2 }}
          />
          <FormControl sx={{ minWidth: 200, mb: 3 }}>
            <InputLabel id="site-select-label">Select Site</InputLabel>
            <Select
              labelId="site-select-label"
              value={selectedSite}
              label="Select Site"
              onChange={handleSiteChange}
              variant="outlined"
            >
              {sites.map((site) => (
                <MenuItem key={site} value={site}>
                  {site}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {/* Camera Streams Grid */}
        {filteredCameras.length > 0 ? (
          filteredCameras.map((camera) => (
            <Grid item xs={12} sm={6} md={6} key={camera.id}>
              <CameraContainer>
                <Typography variant="subtitle2" sx={{ p: 1 }}>
                  {camera.site} - {camera.id}
                </Typography>
                <ReactPlayer
                  url={camera.url}
                  playing
                  controls
                  width="100%"
                  height="100%"
                  config={{ file: { attributes: { autoPlay: true } } }}
                />
              </CameraContainer>
            </Grid>
          ))
        ) : (
          <Grid item xs={12}>
            <Typography color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
              No cameras available for this site
            </Typography>
          </Grid>
        )}
      </Grid>
    </RootStyle>
  );
}

export default CameraFeedPage;
